<!-- Brand Logo -->
<a href='https://booking.cktechsoln.in/' class="brand-link border-bottom-0 text-center">
  <img src="../../../../assets/img/murugan-logo.jpg" class="logo-image bg-white" style="width: 80px;height: 80px;">
</a>

<!-- Sidebar -->
<div class="sidebar">
    <div class="form-inline">
        <app-sidebar-search></app-sidebar-search>
    </div>

    <!-- Sidebar Menu -->
    <nav class="mt-2" style="overflow-y: hidden">
        <ul
            class="nav nav-pills nav-sidebar flex-column"
            data-widget="treeview"
            role="menu"
            data-accordion="false"
        >
            <app-menu-item *ngFor="let item of menu" [menuItem]="item" />
        </ul>
    </nav>
</div>
